import { render } from "./MenuBarItem.vue?vue&type=template&id=3e10125a&scoped=true"
import script from "./MenuBarItem.vue?vue&type=script&lang=js"
export * from "./MenuBarItem.vue?vue&type=script&lang=js"

import "./MenuBarItem.vue?vue&type=style&index=0&id=3e10125a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\user\\Desktop\\project\\sparta\\sparta-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e10125a"]])

export default __exports__